<template>
  <div id="tmg-io" v-bind:class="{'isMobile': isMobile()}">
    <SiteHeader v-bind:class="{'filled': headerClass}"/>
      <router-view></router-view>
      <!--<Modal v-if="showModal" @close="showModal = false"/>-->
    <SiteFooter v-bind:isContactPage="isContactPage" v-if="shouldRenderFooter"/>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter/SiteFooter.vue'
import Modal from '@/components/Modal/Modal.vue'
import favIconUrl from '@/assets/favicon.png'

export default {
  name: 'tmg-io',
  components: {
    SiteHeader,
    SiteFooter,
    Modal
  },
  data: function () {
    return {
      isContactPage: false,
      shouldRenderFooter: true,
      showModal: false,
      headerClass: false
    }
  },
  metaInfo: {
    // if subcomponents don't specify a title, this title will be used
    title: 'TMG.io',
    // all titles will be injected into this template
    titleTemplate: '%s | TMG.io',
    meta: [
      // Heady Stuff
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {name: 'description', content: 'TMG is a team of SAP Commerce (Hybris) & Adobe Marketing Cloud professionals with years of experience delivering efficient and comprehensive end to end solutions.'},
      // OpenGraph data
      {property: 'og:title', content: 'TMG.io'},
      {property: 'og:site_name', content: 'TMG.io'},
      {property: 'og:type', content: 'website'},
      // Should the the same as your canonical link
      {property: 'og:url', content: 'https://tmg.io/#/'},
      {property: 'og:image', content: 'https://tmg.io/static/img/tmg-logo.a1bfc38.png'},
      {property: 'og:description', content: 'TMG is a team of SAP Hybris (Hybris)& Adobe Marketing Cloud professionals with years of experience delivering efficient and comprehensive end to end solutions.'},
      // Twitter card
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:site', content: 'https://tmg.io/#/'},
      {name: 'twitter:title', content: 'TMG.io'},
      {name: 'twitter:description', content: 'TMG is a team of SAP Commerce (Hybris) & Adobe Marketing Cloud professionals with years of experience delivering efficient and comprehensive end to end solutions.'},
      // twitter handle
      {name: 'twitter:image:src', content: 'https://tmg.io/static/img/tmg-logo.a1bfc38.png'},
      // Google / Schema.org markup:
      {itemprop: 'name', content: 'TMG.io'},
      {itemprop: 'description', content: 'TMG is a team of SAP Commerce (Hybris) & Adobe Marketing Cloud professionals with years of experience delivering efficient and comprehensive end to end solutions.'},
      {itemprop: 'image', content: 'https://tmg.io/static/img/tmg-logo.a1bfc38.png'}
    ],
    link: [
      {rel: 'icon', type: 'image/png', href: favIconUrl}
    ]
  },
  created () {
    this.isContactPage = this.$route.path.includes('contact')
    this.headerClass = this.$route.path.includes('404')
    this.handleShowFooter()
  },
  watch: {
    '$route': function () {
      this.isContactPage = this.$route.path.includes('contact')
      this.headerClass = this.$route.path.includes('404')
      this.handleShowFooter()
    }
  },
  mounted () {
    // if (!localStorage.getItem('showModal')) this.showModal = true
  },
  methods: {
    handleShowFooter: function () {
      if (this.$route.path.includes('yeti') || this.$route.path.includes('404')) {
          return this.shouldRenderFooter = false
      }
      else {
          return this.shouldRenderFooter = true
      }
    },
    isMobile: function() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}

</script>

<style src="./style.css"></style>



// WEBPACK FOOTER //
// src/tmg-io.vue